module.exports = __webpack_public_path__ + "img/qx3.3b1d14ba.png";